/**
 * Exam boards are stored by their syllabus code (CIE, EDEXCEL...), but students
 * do not read papers in those terms — they know the board by name. Anywhere a
 * board is shown to a user, run it through this first.
 */
const BOARD_NAMES = {
  CIE: "Cambridge",
  CAIE: "Cambridge",
  EDEXCEL: "Edexcel",
  AQA: "AQA",
  OCR: "OCR",
  WJEC: "WJEC",
};

export const formatExamBoard = (code) => {
  if (!code) return "";
  const key = String(code).trim().toUpperCase();
  return BOARD_NAMES[key] || code;
};

export default formatExamBoard;
